import { render, staticRenderFns } from "./BaseTaglist.vue?vue&type=template&id=e31e900c&"
import script from "./BaseTaglist.vue?vue&type=script&lang=js&"
export * from "./BaseTaglist.vue?vue&type=script&lang=js&"
import style0 from "./BaseTaglist.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports